export default __webpack_public_path__ + "static/media/5.1.de8c3451.mp4";